export enum MEETING_STATUS {
  DRAFT = "DRAFT",
  NOT_START_YET = "NOT_START_YET",
  ON_GOING = "ON_GOING",
  DELAY = "DELAY",
  COMPLETED = "COMPLETED",
  REJECT = "REJECT",
  PENDING = "PENDING",
}
export const status_meeting_calendar: {
  label: string;
  value: string;
}[] = [
  {
    label: "บันทึกร่าง", // i18n-ignore: status label, translated at render site
    value: MEETING_STATUS.DRAFT,
  },
  {
    label: "ยังไม่ถึงกำหนดประชุม", // i18n-ignore: status label, translated at render site
    value: MEETING_STATUS.NOT_START_YET,
  },
  {
    label: "อยู่ระหว่างการประชุม", // i18n-ignore: status label, translated at render site
    value: MEETING_STATUS.ON_GOING,
  },
  {
    label: "เลยกำหนดการประชุม", // i18n-ignore: status label, translated at render site
    value: MEETING_STATUS.DELAY,
  },
  {
    label: "ดำเนินการเสร็จสิ้น", // i18n-ignore: status label, translated at render site
    value: MEETING_STATUS.COMPLETED,
  },
  // {
  //   label: "รอดำเนินการ",
  //   value: MEETING_STATUS.PENDING,
  // },
  // {
  //   label: "ยังไม่ถึงกำหนดประชุม",
  //   value: MEETING_STATUS.REJECT,
  // },
];

export const renderStatus = (value: string): string => {
  return (
    status_meeting_calendar.find((x) => x.value === value)?.label ||
    status_meeting_calendar.find((x) => x.value.split(",").includes(value))
      ?.label ||
    ""
  );
};
